import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const receiptSettingsStyle = StyleSheet.create({
    buttonContainer: {
        alignItems: "center",
        marginVertical: 20,
        marginHorizontal: 15,
        flexDirection: "row",
        alignSelf: "flex-end",
        columnGap: 10
    },
    previewButtonStyle: {
        backgroundColor: appColors?.light,
        borderRadius: 10,
        paddingHorizontal: 15,
        borderWidth: 1,
        borderColor: appColors?.primary
    },
    saveButtonStyle: {
        backgroundColor: appColors?.primary,
        borderRadius: 10,
    },
    contentOuterView: {
        backgroundColor: appColors?.light,
        marginHorizontal: 15,
        borderRadius: 10,
        padding: 15
    },
    contentInnerContainer: {
        marginVertical: 10,
        flexDirection: "row",
        alignItems: "flex-start",
        flexWrap: "wrap"
    },
    dropdownView: {
        marginHorizontal: 15,
        marginBottom: 25,
        // zIndex: 10
    },
    logoContainer: {
        alignSelf: "flex-start",
        marginHorizontal: 15,
        marginTop: 5,
        marginBottom: 20,
        height: 150,
        width: "50%",
        borderWidth: 0.3,
        borderColor: appColors?.grey,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 15
    },
    editIconContainer: {
        position: "absolute",
        backgroundColor: appColors?.light,
        top: -7,
        right: -7,
        borderRadius: 40
    },
    backButtonView: {
        alignItems: "flex-end",
        marginVertical: 15,
        marginHorizontal: 15
    },
    outerContainer: {
        alignSelf: "center",
        backgroundColor: appColors?.light,
        borderRadius: 10
    },
    detailsOuterContainer: {
        marginHorizontal: 10,
        justifyContent: "space-between",
    },
    headerView: {
        marginHorizontal: 20,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    },
    productSectionView: {
        marginVertical: 20,
        marginHorizontal: 15
    },
    productSectionInnerView: {
        flexDirection: "row",
        alignItems: "flex-start"
    },
    subSectionView: { alignItems: "center" },
    orderDetailsView: {
        marginBottom: 10,
        width: "90%",
        alignSelf: "center"
    },
    orderDetailsInnerView: {
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between"
    },
    dividerStyle: { margin: 10 },
    subDetailsView: {
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
        width: "90%",
        alignSelf: "center"
    }
})